module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/CR-549d0b992408f7675320f0665665c8af.png";